'use strict';

DoohApps
.directive('ngRate', ['$parse', function ($parse) {
    return {
        restrict: 'EA',
        scope: {
            score: '=',
            readonly: '=readonly',
            rateid: '@',
        },
        link: function (scope, elem, attrs, ctrl) {
            if (scope.rateid == undefined) scope.rateid = 'rate'
            var template = '<div id="' + scope.rateid + '"></div>';
            elem.append(template);

            $(elem).find('#' + scope.rateid).raty({
                path: 'Content/img',
                score: scope.score,
                readOnly: scope.readonly,
                click: function (score, evt) {
                    scope.$apply(function (scope) {
                        scope.score = parseInt(score);
                    });
                }
            });

            scope.$watch(function () { return scope.score }, function (newValue, oldValue) {
                $(elem).find('#' + scope.rateid).raty({
                    path: 'Content/img',
                    score: scope.score, readOnly: scope.readonly,
                    click: function (score, evt) {
                        scope.$apply(function (scope) {
                            scope.score = parseInt(score);
                        });
                    }
                });
            });
        }
    };
}]);